
export default function Products() {
  return (
    <section id="products" className="bg-white py-32 px-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <div className="inline-block px-6 py-2 rounded-full border-2 border-[#1a1f36] mb-6">
            <span className="text-sm text-[#1a1f36] font-medium">Our Products</span>
          </div>
          <h2 className="text-6xl font-bold text-[#1a1f36] mb-6 leading-tight">
            Innovative Solutions<br />for iOS Users
          </h2>
          <p className="text-lg text-[#6b7280] max-w-2xl mx-auto">
            Discover our flagship applications designed to enhance your mobile experience with cutting-edge technology
          </p>
        </div>

        <div className="grid grid-cols-2 gap-10 mt-20" data-product-shop>
          <div className="relative rounded-3xl bg-gradient-to-br from-[#1a1f36] to-[#4a90e2] p-12 min-h-[500px] flex flex-col justify-between overflow-hidden group hover:scale-105 transition-transform duration-300">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-32 -mt-32"></div>
            <div className="relative z-10">
              <div className="w-16 h-16 flex items-center justify-center mb-8">
                <i className="ri-shield-line text-white text-5xl"></i>
              </div>
              <h3 className="text-4xl font-bold text-white mb-6">VPN Application</h3>
              <p className="text-white/90 text-lg leading-relaxed">
                Secure your online presence with military-grade encryption. Browse anonymously, access global content, and protect your data from prying eyes with our lightning-fast VPN solution.
              </p>
            </div>
            <div className="relative z-10 mt-8">
              <span className="inline-block px-4 py-2 rounded-full bg-white/20 backdrop-blur-sm text-white text-sm">Security</span>
            </div>
          </div>

          <div className="relative rounded-3xl bg-gradient-to-br from-[#10b981] to-[#14b8a6] p-12 min-h-[500px] flex flex-col justify-between overflow-hidden group hover:scale-105 transition-transform duration-300">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-32 -mt-32"></div>
            <div className="relative z-10">
              <div className="w-16 h-16 flex items-center justify-center mb-8">
                <i className="ri-brush-line text-white text-5xl"></i>
              </div>
              <h3 className="text-4xl font-bold text-white mb-6">Cleaner Application</h3>
              <p className="text-white/90 text-lg leading-relaxed">
                Optimize your device performance with intelligent cleaning algorithms. Remove junk files, manage storage efficiently, and keep your iOS device running at peak performance.
              </p>
            </div>
            <div className="relative z-10 mt-8">
              <span className="inline-block px-4 py-2 rounded-full bg-white/20 backdrop-blur-sm text-white text-sm">Optimization</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
